
import TenlifeButton from '../common/TenlifeButton.vue';

export default {
    name: "FiveStarProductsSubcategoryOptionsV2",
    components: { TenlifeButton },
    props: {
        data: {
            type: Array,
            default: () => ([]),
        },
    },
    data() {
        return {
          buttonStyle: {
            normal: {
              backgroundColor: 'transparent',
              textColor: '#16B7A6',
              borderColor: '#16B7A6',
            },
            active: {
              backgroundColor: '#16B7A6',
              textColor: '#white',
              borderColor: '#16B7A6',

            }
          }
        };
    },
    computed: {
      subcategories() {
        return (this.data?.length > 1) ? this.data : null
      }
    },

    mounted() {
      if (!this.$route?.params?.any2) {
        this.$router.push({path: this.localePath('/5star-products-2025/' + this.$route.params.any + '/' + this.firstSubCatSlug())})
      }
    },

    methods: {
      firstSubCatSlug() {
        if (this.subcategories?.length >0) {
          return this.subcategories[0]?.Slug
        }
        return ''
      },
      prepareButtonData(isActive, title, slug) {
        const data = {}
        if (isActive) {
          return Object.assign(data , {
            text: title, 
            icon: '', 
            buttonColor: this.buttonStyle.active.backgroundColor, 
            buttonBorderColor: this.buttonStyle.active.borderColor,
            textColor: this.buttonStyle.active.textColor,
            // link: this.$router.currentRoute.path + '/' + slug,
            disabled: true,
          })
        } else {
          return Object.assign(data , {
            text: title, 
            icon: '', 
            buttonColor: this.buttonStyle.normal.backgroundColor, 
            buttonBorderColor: this.buttonStyle.normal.borderColor,
            textColor: this.buttonStyle.normal.textColor,
            // link: '../' + slug
            // link: this.$router.currentRoute.path + '/' + slug
            link: '/5star-products-2025/' + this.$route.params.any + '/' + slug
          })
        }
      },

      isSubcategoryValid() {
        return this.subcategories?.find((item) => item.Slug === this.$route?.params?.any2 )
      },

      isActive(slug,index) {
        if (this.$route?.params?.any2 === slug) {
          return true
        }
        if (!this.$route.params.any2 && index === 0) {
          return true
        }
        return false
      },
      
      classNames(slug,index) {
        const classes = []
        classes.push(slug)
        
        if (this.isActive(slug,index)) {
          classes.push('active')
        }
        return classes
      },
    },

}
